<template>
  <section class="quick-quote-info">
    <div class="table">
      <div class="tr">
        <span>Occupancy</span>
        <span v-copy="getAllOptionName26('prop_insured', quoteForm.prop_insured)">{{ getAllOptionName26('prop_insured', quoteForm.prop_insured) }}</span>
      </div>
      <div class="tr">
        <span>Type of Building </span>
        <span v-copy="getAllOptionName26('bldg_types', quoteForm.bldg_typ)">{{ getAllOptionName26('bldg_types', quoteForm.bldg_typ) }}</span>
      </div>
      <div class="tr">
        <span>Gross Floor Area (Indoor & Outdoor)</span>
        <span v-copy="quoteForm.floor_area">{{ quoteForm.floor_area }}</span>
      </div>
      <div class="tr">
        <span>Coverage </span>
        <span v-copy="quoteForm.home_coverage_language">{{ quoteForm.home_coverage_language }}</span>
      </div>
      <div
        v-if="quoteForm.bsc_sum_insured_language"
        class="tr">
        <span>Sum Insured of Building Structure</span>
        <span v-copy="quoteForm.bsc_sum_insured_language">{{  quoteForm.bsc_sum_insured_language }}</span>
      </div>
      <div class="tr">
        <span>Property Age </span>
        <span v-copy="getAllOptionName26('prop_age', quoteForm.prop_age) ">{{ getAllOptionName26('prop_age', quoteForm.prop_age) }}</span>
      </div>
      <div class="tr">
        <span>More Benefits</span>
        <span v-copy="getAllOptionName26('benefits', quoteForm.benefits)">{{ getAllOptionName26('benefits', quoteForm.benefits) }}</span>
      </div>
      <div class="tr">
        <span>
          <!--          <p-->
          <!--            v-for="(item,index) in underwriting"-->
          <!--            :key="index">-->
          <!--            {{item.name}}-->
          <!--          </p>-->
          <p>Confirm All Insurance Underwriting Questions?</p>
        </span>
        <span v-copy="getOptionName('answerList', quick_quote_detail.underwriting_confirm)">{{ getOptionName('answerList', quick_quote_detail.underwriting_confirm) }}</span>
      </div>
      <div
        v-if="benefits.length>0"
        class="tr">
        <span>Insured Items</span>
        <span>
          <span
            v-for="(item,index) in benefits"
            :key="'b'+index"
            v-copy="item">
            {{item}}<br>
          </span>
        </span>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'HousemaidQuickQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    quoteForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed:{
    underwriting(){
      let {quick_quote_detail} = this.quoteForm||{}
      return quick_quote_detail.underwriting||[]
    },
    quick_quote_detail(){
      let {quick_quote_detail} = this.quoteForm||{}
      return quick_quote_detail||{}
    },
    benefits(){
      let {class_id,benefits=[]} = this.quoteForm||{}
      const benefitsList = benefits.reduce((result, item) => {
        result.push(
          this.getAllOptionName26('benefits', item)
        )
        return result
      }, [])
      return benefitsList
    }
  },
  created(){
  }
}
</script>
<style lang="scss" scoped>
</style>
